import { keyBy } from 'lodash';

import { FoodDetails } from '../../../../interfaces/FoodDetails';
import { getMeasurementOptions } from '../../../../utils';
import { FoodFormInitialData } from '../../interfaces/FoodFormInitialData';
import { FoodFormValues } from '../../interfaces/FoodFormValues';
import { foodToFormValues } from '../foodToFormValues/foodToFormValues';

export type FoodFormData = Pick<
  FoodFormInitialData,
  'defaultValues' | 'nxMeasurementsByUnit' | 'amountUnitOptions'
>;

export const getEmptyFormValues = (): FoodFormValues => ({
  id: 0,
  name: '',
  brand: null,
  amountUnit: '',
  recommendedServingSize: 1,
  barcode: '',
  servingSize: '',
  servingPerContainer: '',
  totalPerContainer: null,
  tags: [],
  recommended: false,
  microNutrients: [],
  activeCalendar: false,
  my_net_diary_bean_id: null,
  nutrients: {
    proteins: 0,
    carbs: 0,
    fats: 0,
    sugar: 0,
    fiber: 0,
    veggies: 0,
    sodium: 0,
  },
});

/** `dbMeasurements` is the `api/measurements` list; a Nutritionix-linked food uses its own measurements instead */
export const getFoodFormData = (
  food: FoodDetails | null,
  dbMeasurements: string[],
): FoodFormData => {
  if (!food) {
    return {
      defaultValues: getEmptyFormValues(),
      nxMeasurementsByUnit: null,
      amountUnitOptions: getMeasurementOptions(dbMeasurements),
    };
  }

  const defaultValues = foodToFormValues(food);
  // both checks: a food without a bean id can still carry one measurement (edited database food)
  const nxMeasurements =
    food.my_net_diary_bean_id && food.measurements?.length ? food.measurements : null;

  return {
    defaultValues,
    nxMeasurementsByUnit: nxMeasurements ? keyBy(nxMeasurements, 'unit') : null,
    amountUnitOptions: getMeasurementOptions(
      nxMeasurements?.map(({ unit }) => unit) ?? dbMeasurements,
      defaultValues.amountUnit,
    ),
  };
};
